<div class="grid glb-popup m-0">
  @if (popupMode) {
    <button mat-icon-button [mat-dialog-close]="true"
      style="float: right; background-color: transparent">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
  <div>
    <p-treeTable #pt [value]="taskList" [paginator]="true" dataKey="taskId" selectionMode="single" [loading]="loading"
      [columns]="columns" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="taskId"
      (onNodeExpand)="onNodeExpand($event)" [rows]="25" [rowsPerPageOptions]="[25, 100, 200]"
      showCurrentPageReport="true" styleClass="p-datatable-striped"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
      [totalRecords]="recordTotal" [tableStyle]="{'min-width':'50rem'}" [resizableColumns]="true" [autoLayout]="true"
      [scrollable]="true" [ngStyle]="{ width: 'auto' }" [(contextMenuSelection)]="selectedNode" [contextMenu]="gf"
      (onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"
      (onEditCancel)="onCellEditCancel()" [filters]="filters">
      <ng-template pTemplate="caption">
        @if (showFilter) {
          <div class="d-block text-end ctm_admin">
            <div class="row">
              <div class="col-lg-12">
                <span>
                  <button pButton pRipple class="p-button-text"
                    style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                  (click)="reloadPage()">Clear Filters</button>
                  @if (!outlineNewButton && this.taskSource && this.taskSourceId) {
                    <button pButton pRipple
                      class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;" (click)="addTask(1)">New Task
                    +</button>
                  }
                  @if (outlineNewButton) {
                    <button pButton pRipple class="p-button"
                    style="padding: 0.643rem 0.75rem !important;" (click)="addTask(1)">New Task +</button>
                  }
                </span>
                <!-- <app-import-export importEnabled="false" [dataRetrived]="properties" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export> -->
              </div>
            </div>
          </div>
        }
        <!--<div class="row align-items-center" *ngIf="showFilter">
        <div class="col-lg-9">
          <span style="position: relative; top:-5px">Active Filters: </span> <p-chips [(ngModel)]="activefilter" label="" (onRemove)="removedFilter($event)">
          <ng-template let-item pTemplate="item">
            {{ item.displayName }}
          </ng-template>
        </p-chips>
      </div>
      <div class="col-lg-3 text-right">
        Include status report: <p-inputSwitch [(ngModel)]="loadStatusEnabled" (onChange)="loadLazy(lazyLoadEvent)"></p-inputSwitch>
      </div>
    </div>-->
  </ng-template>
  @if (showFilter) {
    <ng-template pTemplate="header">
      <tr>
        <td [ngStyle]="{'width': '10%'}"></td>
        @for (col of columns; track col) {
          <th [ttSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
            {{ col.header }}<p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
          </th>
        }
        @if (loadStatusEnabled) {
          <th [ngStyle]="{'width': '30%'}">status update</th>
        }
        <th [ngStyle]="{'width': '10%'}">Tags</th>
      </tr>
      <tr>
        <th [ngStyle]="{'width': '10%'}"></th>
        <th [ngStyle]="{'width': '10%'}"></th>
        <th [ngStyle]="{'width': '20%'}"><input [ngStyle]="{'width': '100%'}" pInputText type="text"
        [(ngModel)]="selectedFilterName" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': '10%'}">
          <app-user-search [forSearchBar]="true"
            (onUserSelected)="pt.filter($event.userId, 'assignedToUserVO.userId', 'in')"
            (onUserClearedEvent)="pt.filter(null, 'assignedToUserVO.userId', 'in')"
          [selectedUser]="assignedSearchToUser" [showCreateUser]="false"></app-user-search>
        </th>
        <th [ngStyle]="{'width': '10%'}">
          <app-user-search [forSearchBar]="true"
            (onUserSelected)="pt.filter($event.userId, 'createdByUserVO.userId', 'in')"
            (onUserClearedEvent)="pt.filter(null, 'createdByUserVO.userId', 'in')"
          [selectedUser]="createdBySearchToUser" [showCreateUser]="false"></app-user-search>
        </th>
        <th [ngStyle]="{'width': '10%'}"></th>
        <th [ngStyle]="{'width': '12%'}"></th>
        <th [ngStyle]="{'width': '10%'}"></th>
        <th [ngStyle]="{'width': '15%'}">
          <p-multiSelect class="multiselectdropdown" [options]="statuses" displaySelectedLabel optionLabel="name"
            optionValue="value" appendTo="body" [(ngModel)]="selectedStatusFilter"
            (onChange)="pt.filter($event.value, 'status', 'in');" optionLabel="name" display="chip"
          [displaySelectedLabel]="true"></p-multiSelect>
        </th>
        @if (loadStatusEnabled) {
          <th [ngStyle]="{'width': 'auto'}"></th>
        }
        <th [ngStyle]="{'width': 'auto'}">
          <app-tag-join-filter-select [tagSource]="40" [filterValue]="taskTagSelected"
            [(ngModel)]="selectedFilterTagSearch"
          (getFilteredTags)="getFilteredTags($event, null)"></app-tag-join-filter-select>
        </th>
      </tr>
    </ng-template>
  }

  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns" let-expanded="expanded">
    <tr [ttContextMenuRow]="rowNode" [ttRow]="rowNode"
      [ngStyle]="{'background-color': rowData.ischild ? '#d7eaef' : null}">
      <td [ngStyle]="{'width': '10%'}">
        <span (click)="openCm($event, gf, rowNode)"><i class="pi pi-ellipsis-v" aria-hidden="true"></i></span>
        @if (getNumnerOfTasks(rowData)>0) {
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
        }
        @if (getNumnerOfTasks(rowData)>0) {
          <span>{{getNumnerOfTasks(rowData)}}</span>
        }
      </td>
      <td [ngStyle]="{'width': '10%'}" (click)="onOpenFormEdit(rowData);"
        [style.background-color]="getColorForDue(rowData)" [style.color]="'white'"><span>{{rowData?.dateDue |
      date}}</span></td>
      <!--<td  [ngStyle]="{'width': '20%'}" (click)="onOpenFormEdit(rowData);" >{{rowData?.name}}</td>-->

      <td [ngStyle]="{'width': '20%', 'cursor': 'auto'}" ttEditableColumn [ttEditableColumn]="rowData"
        [ttEditableColumnField]="'name'">
        <p-treeTableCellEditor style="cursor: auto">
          <ng-template pTemplate="input">
            <textarea [(ngModel)]="rowData.name" style="cursor: auto"></textarea>
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.name}}
          </ng-template>
        </p-treeTableCellEditor>
      </td>
      <td [ngStyle]="{'width': '10%'}"
        (click)="pt.filter(rowData?.assignedTo?.userId, 'assignedToUserVO.userId', 'in');assignedSearchToUser=rowData?.assignedTo">
        <span style="color: #3F51B5">{{fullName(rowData?.assignedTo)}}</span>
      </td>
      <td [ngStyle]="{'width': '10%'}"
        (click)="pt.filter(rowData?.createdBy?.userId, 'createdByUserVO.userId', 'in');createdBySearchToUser=rowData?.createdBy">
        <span style="color: #3F51B5">{{fullName(rowData?.createdBy)}}</span>
      </td>
      <td [ngStyle]="{'width': '12%'}" (click)="onOpenFormEdit(rowData);">{{rowData?.dateToFollowup | date}}</td>
      <td [ngStyle]="{'width': '10%'}" (click)="onOpenFormEdit(rowData);"> {{rowData?.dateCreated |
        date}}&nbsp;&nbsp;<span style="color:lightgrey">{{daysFromTodayAbs(rowData?.dateCreated)}}d</span></td>
        <td [ngStyle]="{'width': '12%'}" (click)="onOpenFormEdit(rowData);">{{rowData?.dateCompleted | date}}</td>
        <td [ngStyle]="{'width': '15%'}">
          <p-dropdown appendTo="body" [options]="statuses" [(ngModel)]="rowData.status" [ngStyle]="{'width': '100%'}"
            optionLabel="name" optionValue="value" (onChange)="changeInplaceData($event, rowData)">
          </p-dropdown>
        </td>
        @if (loadStatusEnabled) {
          <td [ngStyle]="{'width': '30%'}">
            @for (note of rowData?.noteList; track note) {
              <p>
                {{note?.description}}
              </p>
            }
          </td>
        }
        <td [ngStyle]="{'width': '10%'}"><app-tag-join-list-select [tagSource]="40" [tagSourceId]="rowData?.taskId"
        [loadedTags]="rowData?.tags" tagType="4"></app-tag-join-list-select></td>
      </tr>
    </ng-template>
  </p-treeTable>
  <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
</div>
</div>

<p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
  @if (taskApiData) {
    <app-task-summary [task]="taskApiData"></app-task-summary>
  }
</p-dialog>